var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeLineFilled = function SvgHomeLineFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.523 1.336a2 2 0 0 0-1.046 0c-.397.108-.732.37-.998.58l-.075.058-6.86 5.336c-.377.292-.709.55-.956.884a3 3 0 0 0-.477.975c-.112.4-.111.82-.11 1.297v7.372c0 .527 0 .982.03 1.357.032.395.103.788.296 1.167a3 3 0 0 0 1.311 1.31c.379.194.772.265 1.167.297.375.03.83.03 1.357.03h11.677c.527 0 .982 0 1.356-.03.395-.032.789-.103 1.167-.296a3 3 0 0 0 1.311-1.311c.193-.379.264-.772.297-1.167.03-.375.03-.83.03-1.357v-7.372c0-.476.001-.896-.11-1.297a3 3 0 0 0-.478-.975c-.247-.334-.579-.592-.956-.884l-6.86-5.336-.074-.058c-.267-.21-.602-.472-1-.58M8 16a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2z",
    clipRule: "evenodd"
  })));
};
export default SvgHomeLineFilled;